<script lang="ts">
  export let amount: number = 100000;
  export let currency: string = 'LAK';
  export let code: string = 'CDEF100';
  export let expiry: string = '2026-03-11T00:00:00.000Z';

  let isCopied: boolean = false;

  const formatDate = (isoString: string) => {
    const date = new Date(isoString);
    return date.toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    });
  };

  const copyCode = async () => {
    try {
      await navigator.clipboard.writeText(code);
      isCopied = true;
      
      setTimeout(() => {
        isCopied = false;
      }, 2000);
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };
</script>

{#if isCopied}
  <div class="fixed top-10 left-1/2 transform -translate-x-1/2 bg-[#3ba1ff] text-white px-6 py-3 rounded-lg shadow-lg z-50 text-sm font-bold transition-all duration-300 flex items-center gap-2 pointer-events-none">
    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg>
    ສຳເນົາລະຫັດສ່ວນຫຼຸດສຳເລັດແລ້ວ
  </div>
{/if}

<div class="flex items-center justify-center">
  
  <div class="w-full max-w-lg drop-shadow-md hover:drop-shadow-xl transition-all duration-200 active:scale-[0.98]">
    
    <button 
      on:click={copyCode} 
      class="ticket-shape relative flex w-full bg-white rounded-xl overflow-hidden text-left cursor-pointer group"
      title="ກົດເພື່ອສຳເນົາລະຫັດ (Click to copy code)"
    >

      <div class="flex items-center justify-center w-20 shrink-0 relative pl-3">
        <div class="text-[#3ba1ff]">
          <svg width="27" height="27" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.08333 14.2917H16.3333V4.08333H4.08333V14.2917ZM0 36.75V0H20.4167V18.375H26.5417V33.6875H31.1354V12.25H28.5833V6.125H29.6042V3.0625H31.6458V6.125H33.6875V3.0625H35.7292V6.125H36.75V12.25H34.1979V36.75H23.4792V21.4375H20.4167V36.75H0ZM9.1875 32.6667L14.2917 24.5H11.2292V18.375L6.125 26.5417H9.1875V32.6667Z" fill="#00AAFF"/>
          </svg>
        </div>
        
        <div class="absolute right-0 top-6 bottom-6 border-r-[2px] border-dashed border-gray-300"></div>
      </div>

      <div class="flex flex-col flex-1 p-6 pl-4 pr-7">
        
        <div class="flex items-baseline flex-wrap gap-x-2 mb-3">
          <span class="text-[#2c3e50] text-sm font-bold">
            ລະຫັດເຕີມເງິນສາກລົດມູນຄ່າ
          </span>
          <span class="text-[#3ba1ff] text-sm font-extrabold">
            {amount.toLocaleString()}
          </span>
          <span class="text-[#2c3e50] text-sm font-bold">
            {currency}
          </span>
        </div>

        <div class="flex items-center gap-x-2 mb-4">
          <span class="text-[#3ba1ff] text-sm font-medium">
            ລະຫັດເຕີມເງິນ :
          </span>
          <span class="text-[#2c3e50] text-sm font-bold">
            {code}
          </span>
        </div>

        <hr class="border-t-[1.5px] border-gray-400 mb-4" />

        <div class="flex items-center gap-x-2">
          <span class="text-[#3ba1ff] text-sm font-medium">
            ກະລຸນາໃຊ້ກ່ອນວັນທີ :
          </span>
          <span class="text-gray-400 text-sm font-medium">
            {formatDate(expiry)}
          </span>
        </div>

      </div>
    </button>
  </div>
</div>

<style>
  /* This creates a perfect transparency mask with 16px circles cut out of the left and right sides */
  .ticket-shape {
    -webkit-mask-image: radial-gradient(circle at 0 50%, transparent 16px, black 16.5px),
                        radial-gradient(circle at 100% 50%, transparent 16px, black 16.5px);
    -webkit-mask-size: 51% 100%;
    -webkit-mask-position: left, right;
    -webkit-mask-repeat: no-repeat;
    
    mask-image: radial-gradient(circle at 0 50%, transparent 16px, black 16.5px),
                radial-gradient(circle at 100% 50%, transparent 16px, black 16.5px);
    mask-size: 51% 100%;
    mask-position: left, right;
    mask-repeat: no-repeat;
  }
</style>